import { cn } from "@utils/tailwind.util";
import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
  className?: string;
}

export function PageHeading({ children, className }: Props) {
  return (
    <h2
      className={cn(
        "flex cursor-default select-none items-center overflow-hidden whitespace-nowrap text-2xl font-semibold leading-7 text-content-primary dark:text-white non-selectable",
        className
      )}
    >
      {children}
    </h2>
  );
}
